import { styled } from "styled-components";

export const ButtonContainer = styled.button`
  width: fit-content;
  height: 4.8rem;
  z-index: 10;
  min-width: 10rem;

  padding: 0 3rem;

  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 1rem;
  border: none;
  outline: none;
  border-radius: 1rem;
  background: linear-gradient(90deg, #fe5f55 0%, #db4f4f 100%);
  transition: all 0.2s ease-in-out;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  box-shadow: ${(props) =>
    props.disabled ? "none" : "0px 8px 12px 0px rgba(0, 0, 0, 0.1)"};
  &:active {
    scale: ${(props) => (props.disabled ? 1 : 0.99)};
  }
  &:hover {
    span {
      text-shadow: 0px 0px 10px white;
    }
    background: linear-gradient(0deg, #fe5f55 0%, #db4f4f 100%);
  }
  @media (max-width: 600px) {
    width: 100% !important;
  }
`;

export const Text = styled.span`
  color: ${(props) => (props.disabled ? "#000" : "#fff")};
  text-align: center;
  font-size: 1.6rem;
  transition: all 0.2s ease-in-out;
  user-select: none;
  font-family: "Avenir-SemiBold";
  letter-spacing: -0.408px;
  white-space: nowrap;
  @media (max-width: 600px) {
    white-space: wrap;
    font-size: 1.45rem;
  }
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
`;
